type CapacityAdjustmentError = {
  forbidden: boolean;
  notFound: boolean;
};

const capacityAdjustmentError: CapacityAdjustmentError = {
  forbidden: false,
  notFound: false,
};

export type { CapacityAdjustmentError };

export { capacityAdjustmentError };
